<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m15 30a14.95 14.95 0 0 1 -10.61-4.4 14.76 14.76 0 0 1 -3.21-4.76 15 15 0 0 1 24.43-16.41 15.13 15.13 0 0 1 3.21 4.77 15 15 0 0 1 -13.82 20.8zm0-28.4a13.44 13.44 0 1 0 13.43 13.4 13.45 13.45 0 0 0 -13.43-13.4z"
      fill="#4f2b1b"
    />
    <path
      d="m11.38 23.81c-.41-.69-.13-5.12 0-6.8a23.59 23.59 0 0 0 .09-2.56 23.39 23.39 0 0 1 1-3.81c1-3.15 1.2-3.9.41-4.24-.08 0-.2-.08-.22-.49a5.07 5.07 0 0 1 2.49-.25h.14a2.74 2.74 0 0 1 2.07.27 1.59 1.59 0 0 1 -.45.58l-.37.29 1.94 6.84c.35 3.29.65 8.94 0 10.08-.36.64-1.09.68-2.37.69-.38 0-.78 0-1.2 0a5.54 5.54 0 0 1 -3.53-.6z"
      fill="#fff"
    />
    <path
      d="m19.84 13.41-1.74-6.15a1.91 1.91 0 0 0 .6-1.63c-.22-1.05-1.7-1.63-3.55-1.37-1-.06-2.75 0-3.52.67a1.19 1.19 0 0 0 -.4.88 2 2 0 0 0 .67 1.64c-.11.58-.5 1.83-.79 2.77a16.21 16.21 0 0 0 -1 4.35c0 .3 0 1.3-.1 2.35-.31 5.09-.31 7.32.53 8a6.14 6.14 0 0 0 3.64 1q.43 0 .87 0h1.11c1.38 0 2.8 0 3.58-1.41 1.01-2.02.2-10.16.1-11.1zm-8.45 10.4c-.41-.69-.14-5.12 0-6.8a24.83 24.83 0 0 0 .1-2.57 24.44 24.44 0 0 1 1-3.8c1-3.15 1.21-3.9.41-4.24-.07 0-.2-.08-.22-.49a5.17 5.17 0 0 1 2.49-.26h.14a2.74 2.74 0 0 1 2.07.27 1.48 1.48 0 0 1 -.45.58l-.36.29 1.94 6.84c.34 3.29.65 8.94 0 10.08-.36.64-1.1.68-2.37.69-.39 0-.79 0-1.21 0a5.57 5.57 0 0 1 -3.54-.59z"
      fill="#4f2b1b"
    />
  </svg>
</template>
